import { Injectable } from '@angular/core';

import * as _ from 'lodash';

import * as sdk from '@mycure/sdk';
import { MycureSDK } from './../../service';

import { Logger } from './../../logger/logger.service';
const log = new Logger('@mycure/mc-services');

@Injectable({
  providedIn: 'root'
})

export class McLisTestAnalyzerService {

  constructor(
    private sdk: MycureSDK,
  ) { 

  }

  /**
   * Load organization's lis analyzers
   * @param id 
   */
  async loadOrgLisAnalyzer(id: string) {
    const query: any = { facility: id };
    const res = await this.sdk.lis.analyzers().find(query);
    return res.items;
  }

  /**
   * Load Specific analyzer
   * @param id 
   */
  loadLisAnalyzer(id: any) {
    return this.sdk.lis.analyzers().get(id);
  }

  createLisAnalyzer(data: any) {
    const values = _.pick(data, ['name', 'description', 'facility']);
    return this.sdk.lis.analyzers().create(values);
  }

  updateLisAnalyzer(id: string, data: any) {
    const values = _.pick(data, ['name', 'description']);
    return this.sdk.lis.analyzers().update(id, values);
  }

  removeLisAnalyzer(id: string) {
    return this.sdk.lis.analyzers().remove(id);
  }
}
